<mat-toolbar class="main-toolbar">
  <mat-toolbar-row class="layout-container toolbar-row">
    <a class="brand" routerLink="/dashboard" aria-label="Go to home page">
      <img
        class="logo"
        src="../../../../../assets/icons/icon_astra.svg"
        alt="AZ Crisis Solutions logo"
      />
      <span class="app-name">AZ Crisis Solutions</span>
    </a>

    <div class="user-chip" aria-label="current user">
      <span class="avatar">RC</span>
      <span class="user-name">Roberto Campos</span>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
